var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsBannerIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 31.5,
    width: 117,
    height: 117,
    stroke: "white",
    strokeWidth: 3,
    strokeDasharray: "9 9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 24.75,
    width: 13.5,
    height: 13.5,
    stroke: "#232327",
    strokeWidth: 13.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141.75,
    y: 24.75,
    width: 13.5,
    height: 13.5,
    stroke: "#232327",
    strokeWidth: 13.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 141.75,
    width: 13.5,
    height: 13.5,
    stroke: "#232327",
    strokeWidth: 13.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141.75,
    y: 141.75,
    width: 13.5,
    height: 13.5,
    stroke: "#232327",
    strokeWidth: 13.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126 55.5H57V76.5H77.9998L77.9998 127.5H105L105 76.5H126V55.5Z",
    fill: "#434652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsBannerIcon2);
export default __webpack_public_path__ + "static/media/skills-bannerIcon_2.fd9511f9535c1fc0eeeeedf0002523f7.svg";
export { ForwardRef as ReactComponent };